import { makeStyles } from 'tss-react/mui';
import { themeColors } from 'app/shared/theme/theme';

export const useStyles = makeStyles()({
  formControl: {
    minWidth: '67px',
    minHeight: '38px',
    marginLeft: '10px',
    backgroundColor: themeColors.white,
  },

  select: {
    padding: '9px 12px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: themeColors.accentDark,
    paddingTop: '50px',
    backgroundColor: themeColors.greyscale5,
  },
  containerVariant: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    color: themeColors.accentDark,
    paddingTop: '50px',
    backgroundColor: themeColors.greyscale5,
  },
  icon: {
    height: '16px',
  },
  pagination: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  pages: {
    margin: '0px 22px 0px 22px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  pagesVariant: {
    margin: '0px 10px 0px 10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
